{
  "name": "integration.portal.frontend",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "engines": {
    "node": ">=24"
  },
  "prettier": {
    "trailingComma": "es5",
    "tabWidth": 2,
    "semi": true,
    "singleQuote": true,
    "useTabs": false,
    "printWidth": 120,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^21.0.1",
    "@angular/common": "^21.1.1",
    "@angular/compiler": "^21.1.1",
    "@angular/core": "^21.1.1",
    "@angular/forms": "^21.1.1",
    "@angular/material": "^21.0.1",
    "@angular/platform-browser": "^21.1.1",
    "@angular/router": "^21.1.1",
    "@azure/msal-angular": "^4.0.22",
    "@azure/msal-browser": "^4.26.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.1",
    "@angular/cli": "^21.1.1",
    "@angular/compiler-cli": "^21.1.1",
    "@chiragrupani/karma-chromium-edge-launcher": "^2.5.1",
    "@semantic-release/exec": "^7.1.0",
    "@semantic-release/git": "^10.0.1",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "semantic-release": "^25.0.3",
    "semantic-release-export-data": "^1.2.0",
    "typescript": "~5.9.2"
  }
}
